// @flow
import React from 'react';

type Props = {
  size?: number | string,
  width?: number | string,
  height?: number | string,
  color?: string,
  fill?: string,
  className?: string,
  style?: Object,
};

const BoltIcon = ({
  size,
  width,
  height,
  color,
  fill,
  className,
  style,
}: Props) => {
  const iconFill = color || fill || 'currentColor';
  const iconWidth = width || size;
  const iconHeight = height || size;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={iconWidth}
      height={iconHeight}
      fill={iconFill}
      className={className}
      style={{ flexShrink: 0, ...style }}
      aria-hidden="true"
    >
      <path d="M13 2L4.5 13.5H11L9.5 22L19.5 10.5H13L14.5 2H13Z" />
    </svg>
  );
};

export default BoltIcon;

